'use strict';

module.exports = {
  SHARE_TYPE: {
    FB: 'Facebook',
    FB_CLIENT: 'FB_CLIENT',
    CLIENT: 'Client',
    WHATSAPP: 'Whatsapp',
    OK: 'OK',
    VK: 'VK',
    HIDDEN: 'hidden',
    DOWNLOAD: 'DOWNLOAD',
    WHATSAPP_CLIENT: 'WHATSAPP_CLIENT',
    VK_CLIENT: 'VK_CLIENT',
    JSSDK: 'JSSDK' // android >= 12.10.0
  },
  // 对应的账号是sunnie_sun_880101@hotmail.com,负责该账号的同学：xyy89777@alibaba-inc.com
  // 目前该APP_ID 可应用的域名是 *.ucweb.com
  FB_APP_ID: '750369031797093',
  FB_SHARE_DOMAIN_NAME: ['ucweb.com'],
  UPDATE_SHARE_TYPE: 'UPDATE_SHARE_TYPE'
};